import {useMutation, useQueryClient} from 'react-query';
import PostFarmAdvertisement from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

interface IPostFarmAdvertisementProps {
  onSuccess?: (response: IAddedAdvertisementResponse) => void;
}

const usePostFarmAdvertisement = ({onSuccess}: IPostFarmAdvertisementProps) => {
  const queryClient = useQueryClient();

  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IFarmAdvertisementPayload) => {
      return PostFarmAdvertisement(payload);
    },

    onSuccess: data => {
      if (onSuccess) {
        onSuccess(data); // Passing the response to onSuccess
      }

      queryClient.invalidateQueries({queryKey: ['my-ads']}); // Invalidate personal ads
      queryClient.invalidateQueries({queryKey: ['get-store-lab-views']}); // Invalidate store ads
    },

    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePostFarmAdvertisement};
